const NORMAL_LINE_WIDTH = 1.5;
const SELECTED_LINE_WIDTH = 3;
const IGNORED_LINE_WIDTH = 1;
const HIDDEN_LINE_WIDTH = 0;
const HIGHLIGHT_LINE_WIDTH = 3;
const UI_NORMAL_LINE_WIDTH = 1;
const UI_BOLD_LINE_WIDTH = 2;
const NO_DASH = [0];
const DOTTED = [3, 3];
const DASHED = [7, 5];

export default {
    selectionRectangle(item) {
        if (item == null) return;
        item.strokeWidth = HIGHLIGHT_LINE_WIDTH;
        item.strokeColor = '#59ABFF';
        item.fillColor = 'rgba(255,255,255,0.001)';
        item.dashArray = NO_DASH;
        item.strokeScaling=false;
    },

    selectionRectangleInUse(item) {
        if (item == null) return;
        item.strokeWidth = HIDDEN_LINE_WIDTH;
    },

    magneticLine(item) {
        if (item == null) return;
        item.strokeWidth = UI_BOLD_LINE_WIDTH;
        item.strokeColor = "#59ABFF";
        item.strokeScaling = false;
    },

    magneticTarget(item) {
        if (item == null) return;
        item.strokeWidth = UI_BOLD_LINE_WIDTH;
        item.strokeColor = "#59ABFF";
        item.strokeScaling = false;
    },

    transform(item) {
        if (item == null) return;
        item.strokeWidth = NORMAL_LINE_WIDTH;
        item.strokeColor = "rgba(100,100,255,0.8)";
        item.fillColor = 'rgba(30,30,100,0.3)';
        item.dashArray = NO_DASH;
        item.strokeScaling = false;
    },

    selectingRectangle(item) {
        if (item == null) return;
        item.strokeWidth = NORMAL_LINE_WIDTH;
        item.strokeColor = "rgba(100,100,100,0.8)";
        item.fillColor = 'rgba(200,200,200,0.3)';
        item.dashArray = DOTTED;
        item.strokeScaling=false;
    },

    solid(item) {
        if (item == null) return;
        item.strokeColor = '#373737';
        item.strokeWidth = NORMAL_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = '#f3f3f3';
        item.strokeScaling=false;
    },

    solidMetal(item) {
        if (item == null) return;
        item.strokeColor = '#373737';
        item.strokeWidth = HIGHLIGHT_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = '#dbd8d8';
        item.strokeScaling=false;
    },

    solidWood(item) {
        if (item == null) return;
        item.strokeColor = '#373737';
        item.strokeWidth = HIGHLIGHT_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = '#eab875';
        item.strokeScaling=false;
    },

    invalidSize(item) {
        if (item == null) return;
        item.strokeColor = '#99294b';
        item.strokeWidth = HIGHLIGHT_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = '#f3f3f3';
        item.strokeScaling = false;
    },

    transparent(item) {
        if (item == null) return;
        item.strokeWidth = NORMAL_LINE_WIDTH;
        item.strokeColor = 'rgba(50,50,50,0.3)';
        item.fillColor = 'rgba(255,255,255,0.001)';
        item.dashArray = DASHED;
        item.strokeScaling = false;
    },

    originalPath(item) {
        item.strokeWidth = NORMAL_LINE_WIDTH;
        item.strokeColor = 'rgba(100, 100, 100, 0.4)';
        item.fillColor = 'rgba(255,255,255,0.001)';
        item.dashArray = DASHED;
        item.strokeScaling = false;
    },

    cuttable(item) {
        if (item == null) return;
        item.strokeColor = '#373737';
        item.strokeWidth = NORMAL_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = null;
        item.strokeScaling=false;
    },

    removed(item) {
        if (item == null) return;
        item.strokeColor = '#59ABFF';
        item.strokeWidth = HIGHLIGHT_LINE_WIDTH;
        item.dashArray = DOTTED;
        item.fillColor = '#f3bc00';
        item.strokeScaling = false;
        item.strokeJoin = 'round';
    },

    beforeCorrection(item) {
        if (item == null) return;
        item.strokeColor = '#ee1111';
        item.strokeWidth = NORMAL_LINE_WIDTH;
        item.fillColor = 'rgba(255,255,255,0.001)';
        item.dashArray = DOTTED;
        item.strokeScaling = false;
    },

    afterCorrection(item) {
        if (item == null) return;
        item.strokeColor = '#11ee11';
        item.strokeWidth = HIGHLIGHT_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = null;
        item.strokeScaling = false;
    },

    error(item) {
        if (item == null) return;
        item.strokeColor = '#fe2739';
        item.strokeWidth = HIGHLIGHT_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = '#f67c84';
        item.strokeScaling=false;
    },

    arrow(item) {
        if (item == null) return;
        item.strokeColor = '#e83c69';
        item.strokeWidth = HIGHLIGHT_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.strokeScaling=false;
    },

    suiviLine(item) {
        if (item == null) return;
        item.strokeWidth = UI_NORMAL_LINE_WIDTH;
        item.strokeColor = "#59ABFF";
        item.strokeScaling = false;
        item.dashArray = DOTTED;
    },

    cotesLine(item) {
        if (item == null) return;
        item.strokeWidth = UI_NORMAL_LINE_WIDTH;
        item.strokeColor = "#59ABFF";
        item.strokeScaling = false;
        item.dashArray = NO_DASH;
    },

    xAxis(item) {
        if (item == null) return;
        item.strokeWidth = NORMAL_LINE_WIDTH;
        item.strokeColor = "#df1313";
        item.strokeScaling = false;
        item.dashArray = NO_DASH;
    },

    yAxis(item) {
        if (item == null) return;
        item.strokeWidth = UI_BOLD_LINE_WIDTH;
        item.strokeColor = "#76d446";
        item.strokeScaling = false;
        item.dashArray = NO_DASH;
    },

    offset(item) {
        if (item == null) return;
        item.strokeColor = '#ff1111';
        item.strokeWidth = UI_BOLD_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = null;
        item.strokeScaling = false;
    },

    customHandle(item) {
        if (item == null) return;
        item.strokeColor = '#59ABFF';
        item.strokeWidth = UI_BOLD_LINE_WIDTH;
        item.dashArray = NO_DASH;
        item.fillColor = '#f5f5f5';
        item.strokeScaling = false;
    },

    importItem(item) {
        if (item == null) return;
        item.strokeWidth = IGNORED_LINE_WIDTH;
    },

    blueprintItem(item) {
        if (item == null) return;
        item.strokeWidth = SELECTED_LINE_WIDTH;
        item.fillColor = 'rgba(255,255,255,0.001)';
        item.dashArray = NO_DASH;
        item.strokeScaling = false;
    },

    hideItem(item) {
        if (item == null) return;
        item.strokeWidth = HIDDEN_LINE_WIDTH;
    },

    copyStyle(item, toCopy) {
        if (item == null || toCopy == null) return;
        item.strokeColor = toCopy.strokeColor;
        item.strokeWidth = toCopy.strokeWidth;
        item.dashArray = toCopy.dashArray;
        item.fillColor = toCopy.fillColor;
        item.strokeScaling = toCopy.strokeScaling;
    }
}
